<template>
  <v-stepper-content step="3">
    <form>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
          <v-text-field
                  v-model="user.addressAttributes.company"
                  v-validate="'required|min:2|unique:vendor-name'"
                  :error-messages="errors.collect('company')"
                  :label="$t('userRegistrationSteps.form.company')"
                  data-vv-name="company"
                  data-vv-delay="500"
                  :data-vv-as="$t('userRegistrationSteps.form.company')"
                  required
                  outlined
                  height="43"
          ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="this.user.role !== 'client'">
            <v-text-field
                    v-model="user.addressAttributes.firstname"
                    v-validate="'required|min:3'"
                    :error-messages="errors.collect('firstname')"
                    :label="$t('userRegistrationSteps.form.firstname')"
                    data-vv-name="firstname"
                    :data-vv-as="$t('userRegistrationSteps.form.firstname')"
                    required
                    outlined
                    height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="this.user.role !== 'client'">
            <v-text-field
                    v-model="user.addressAttributes.lastname"
                    v-validate="'required|min:3'"
                    :error-messages="errors.collect('lastname')"
                    :label="$t('userRegistrationSteps.form.lastname')"
                    data-vv-name="lastname"
                    :data-vv-as="$t('userRegistrationSteps.form.lastname')"
                    required
                    outlined
                    height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="user.addressAttributes.address1"
              v-validate="'required'"
              :error-messages="errors.collect('address1')"
              :label="$t('userRegistrationSteps.form.address1')"
              data-vv-name="address1"
              :data-vv-as="$t('userRegistrationSteps.form.address1')"
              required
              outlined
              height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="user.addressAttributes.city"
              v-validate="'required'"
              :error-messages="errors.collect('city')"
              :label="$t('userRegistrationSteps.form.city')"
              data-vv-name="city"
              :data-vv-as="$t('userRegistrationSteps.form.city')"
              required
              outlined
              height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="user.addressAttributes.zipcode"
              v-validate="'required|max:8'"
              :error-messages="errors.collect('zipcode')"
              :label="$t('userRegistrationSteps.form.zipcode')"
              data-vv-name="zipcode"
              :data-vv-as="$t('userRegistrationSteps.form.zipcode')"
              required
              outlined
              height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="user.addressAttributes.countryId"
              :items="countries"
              :loading="isLoadingCountries"
              :search-input.sync="searchCountries"
              cache-items
              hide-no-data
              hide-selected
              item-text="name"
              item-value="id"
              v-validate="'required'"
              :error-messages="errors.collect('country')"
              :label="$t('userRegistrationSteps.form.country')"
              data-vv-name="country"
              :data-vv-as="$t('userRegistrationSteps.form.country')"
              required
              outlined
              height="43"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="user.addressAttributes.stateId"
              :items="states"
              :loading="isLoadingStates"
              :search-input.sync="searchStates"
              hide-no-data
              hide-selected
              item-text="name"
              item-value="id"
              v-validate="'required'"
              :error-messages="errors.collect('state')"
              :label="$t('userRegistrationSteps.form.state')"
              data-vv-name="state"
              :data-vv-as="$t('userRegistrationSteps.form.state')"
              required
              outlined
              height="43"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="user.addressAttributes.phone"
              v-validate="'required|min:9|numeric'"
              :error-messages="errors.collect('phone')"
              :label="$t('userRegistrationSteps.form.phone')"
              data-vv-name="phone"
              :data-vv-as="$t('userRegistrationSteps.form.phone')"
              required
              outlined
              height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12" v-if="user.role === 'designer'">
            <v-textarea
              v-model="user.description"
              v-validate="'required'"
              :error-messages="errors.collect('description')"
              :label="$t('userRegistrationSteps.form.description')"
              data-vv-name="description"
              :data-vv-as="$t('userRegistrationSteps.form.description')"
              required
              outlined
            ></v-textarea>
          </v-col>
          <v-col cols="12" v-if="user.role === 'designer'">
            <v-text-field
              v-model="user.url"
              v-validate="'required|url'"
              :error-messages="errors.collect('url')"
              :label="$t('userRegistrationSteps.form.url')"
              data-vv-name="url"
              :data-vv-as="$t('userRegistrationSteps.form.url')"
              required
              outlined
              height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="user.receiveLatestNews"
              :error-messages="errors.collect('receiveLatestNewsLabel')"
              data-vv-name="receiveLatestNewsLabel"
              :data-vv-as="$t('userRegistrationSteps.form.receiveLatestNewsLabel')"
              color="primary"
            >
              <template slot="label">
                <span v-html="$t('userRegistrationSteps.form.receiveLatestNewsDescription')"></span>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="user.termsAndConditions"
              v-validate="'required:true'"
              :error-messages="errors.collect('termsAndConditionsLabel')"
              data-vv-name="termsAndConditionsLabel"
              :data-vv-as="$t('userRegistrationSteps.form.termsAndConditionsLabel')"
              color="primary"
            >
              <template slot="label">
                <i18n path="userRegistrationSteps.form.termsAndConditionsDescription" tag="span">
                  <a href='terms-and-conditions' slot="terms" @click.stop target='_blank'>{{$t('userRegistrationSteps.form.termsAndConditionsLabel')}}</a>
                  <a href="privacy-policy" slot="privacy" @click.stop target="_blank">{{$t('userRegistrationSteps.form.privacyPolicyLabel')}}</a>
                </i18n>
              </template>
            </v-checkbox>
            <p v-if="this.user.role === 'corporate'" class="v-label theme--light light">* {{$t('userRegistrationSteps.form.freeAccountInfo')}}</p>
          </v-col>
          <v-col cols="10" offset="1" xl="4" offset-xl="4" sm="8" offset-sm="2" lg="4" offset-lg="4" class="mt-3">
            <v-btn
              color="primary"
              depressed
              width="100%"
              height="43px"
              @click="sendForm(); facebookTrack();"
              :loading="settings.formSubmitting"
              :disabled=isDisabled
            >
              {{saveButtonTranslation}}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </form>
  </v-stepper-content>
</template>

<script>
  export default {
    name: 'FirstStep',
    props: ['user', 'settings', 'customerType'],
    data: () => ({
      descriptionLimit: 6,
      countries: [],
      states: [],
      isLoadingCountries: false,
      isLoadingStates: false,
      searchCountries: null,
      searchStates: null,
    }),
    computed: {
      saveButtonTranslation() {
        if (this.user.role === 'designer') {
          return this.$t('userRegistrationSteps.stepper.sendApplication');
        } else {
          return this.$t('userRegistrationSteps.stepper.signUp');
        }
      },
      isDisabled() {
        if (this.user.termsAndConditions) {
          return false;
        } else {
          return true;
        }
      }
    },
    methods: {
      sendForm() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$emit('submitForm');
          }
        });
      },
      goBack() {
        this.$emit('goBack');
      },
      // Facebook code
      facebookTrack() {
        fbq('track', 'CompleteRegistration', {
          value: 1,
          currency: 'EUR',
        });
      }
    },
    watch: {
      searchCountries(val) {
        if (this.isLoadingCountries) return;
        this.isLoadingCountries = true;

        fetch(`/api/v1/countries?q[name_cont]=${val}&per_page=50&q[name]=desc`).then(res => res.json()).then(res => {
          const { countries } = res;
          this.countries = countries;
        }).catch(err => {
        }).finally(() => (this.isLoadingCountries = false));
      },
      searchStates(val) {
        if (this.isLoadingStates || val === null) return;
        this.isLoadingStates = true;

        fetch(
          `/api/v1/states?q[name_cont]=${val}&per_page=50&q[name]=desc&country_id=${this.user.addressAttributes.countryId}`).
          then(res => res.json()).
          then(res => {
            const { states } = res;
            this.states = states;
          }).
          catch(err => {
            console.log(err);
          }).
          finally(() => (this.isLoadingStates = false));
      },
      'user.addressAttributes.countryId'() {
        this.states = [];
        this.user.addressAttributes.stateId = '';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .col, .col-12 {
    padding-bottom: 0;
    padding-top: 0;
  }
</style>